export default __webpack_public_path__ + "static/SR France - Kosher - Certificat-7f5710efaec1189d61ed208f3ba3d5e4.pdf";